import { FC, ReactNode, useLayoutEffect, useState } from 'react';
import { createPortal } from 'react-dom';

const defaultReactPortalProps = {
  wrapperId: 'react-portal',
};
const REACT_PORTAL_OWNER_ATTR = 'data-react-portal-owned';

type ReactPortalProps = {
  children: ReactNode | any;
  wrapperId: string;
} & typeof defaultReactPortalProps;
const ReactPortal: FC<ReactPortalProps> = ({ children, wrapperId }) => {
  const [wrapper, setWrapper] = useState<Element | null>(null);

  useLayoutEffect(() => {
    let element = document.getElementById(wrapperId);

    let created = false;

    if (!element) {
      created = true;
      const wrapper = document.createElement('div');
      wrapper.setAttribute('id', wrapperId);
      wrapper.setAttribute(REACT_PORTAL_OWNER_ATTR, 'true');
      document.body.appendChild(wrapper);
      element = wrapper;
    }

    setWrapper(element);

    return () => {
      if (created && element?.parentNode) {
        if (element.getAttribute(REACT_PORTAL_OWNER_ATTR) === 'true') {
          element.remove?.();
        } else {
          console.warn(`Skipping removal of portal wrapper not owned by ReactPortal: ${wrapperId}`);
        }
      }
    };
  }, [wrapperId]);

  if (wrapper) {
    return createPortal(children, wrapper);
  }

  return <></>;
};
export default ReactPortal;
